export default "__VITE_ASSET__BfJCICoN__"